import { Icon } from "@/components/Icon/Icon";
import { Input } from "@/components/primitives";

type SidebarSearchProps = {
  value: string;
  onChange: (value: string) => void;
};

export function SidebarSearch({ value, onChange }: SidebarSearchProps) {
  return (
    <div className="sidebar-search-wrap">
      <div className="sidebar-search-icon">
        <Icon name="search" size={14} />
      </div>
      <Input
        className="sidebar-search-input"
        placeholder="Search flavors"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
